import { atom, SetStateAction } from 'jotai';
import debounce from 'lodash/debounce';

export const atomWithDebounce = <T>(
  initialValue: T,
  delayMilliseconds: number,
) => {
  const $instantValue = atom(initialValue);
  const $debouncedValue = atom(initialValue);

  const $updateDebouncedValue = atom(
    null,
    debounce((_get, set, update: SetStateAction<T>) => {
      set($debouncedValue, update);
    }, delayMilliseconds),
  );

  return {
    value: atom(
      (get) => get($instantValue),
      (_get, set, update: SetStateAction<T>) => {
        set($instantValue, update);
        set($updateDebouncedValue, update);
      },
    ),
    debouncedValue: atom((get) => get($debouncedValue)),
  };
};
